export default __webpack_public_path__ + "static/media/flask.b11d8e7c.png";